const defaultStates = {
  inputValue: '写入任务',
  tabnum: '1'
};
  const detailreducer = (previousState = defaultStates, action) => {
  switch (action.type) {
    case 'tabChange' :
      let newState = JSON.parse(JSON.stringify(previousState));
      newState.tabnum = action.value
      return newState
      default: break;
  }
  return previousState;
}
export default detailreducer